const FATHOM_LAYER_ARRAY = [
  "FL_Fluvial_Global_Fathom",
  "FL_Pluvial_Global_Fathom",
  "FL_Coastal_Global_Fathom"
];
export default FATHOM_LAYER_ARRAY;
